<template>
  <div class="org-qs">
    <div class="infos">
      <div class="info-title"><span></span>注意</div>
      <div>支持Word、Excel文件内容处理；</div>
      <div>购买前请先联系客服发送文件，符合整理条件后再购买。</div>
      <div>
        仍有问题请<span class="pointerLink" @click="handleContact()"
          >联系客服</span
        >
      </div>
    </div>
    <div class="productList" v-if="productList.length">
      <div
        :class="
          productIndex == index ? 'active product-item ' : 'product-item '
        "
        :style="!isMobile ? 'minWidth:106px' : ''"
        v-for="(item, index) in productList"
        :key="item.day"
        @click="changeProduct(index)"
      >
        <div>
          <div class="name">{{ item.name }}</div>
          <div class="price">
            <span class="price-icon">¥</span>{{ item.price }}
          </div>
          <div class="discount">{{ item.discount }}</div>
          <div class="info" v-if="item.info">{{ item.info }}</div>
          <img
            v-if="productIndex == index"
            src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220415/447a645f8ccf856b2edf9db4d16923a0.svg"
          />
        </div>
      </div>
    </div>
    <div class="buy-count" v-if="productList.length">
      <div>购买题数</div>
      <div class="pick">
        <span class="add" :class="{gray: productList[productIndex].item_count * count <= 100}"  @click="handleCount('reduce')">－</span>
        <span class="fill-input">{{
          productList[productIndex].item_count * count
        }}</span>
        <span class="reduce" :class="{gray: productList[productIndex].item_count * count >= 1000}" @click="handleCount('add')">+</span>
      </div>
    </div>
    <div class="buy-btn" @click="pay" v-if="productList.length">
      立即购买
      <div class="r">
        <span class="price-icon">¥</span
        >{{ count * productList[productIndex].price }} 元
      </div>
    </div>
    <div>
      <div class="self-service-head">自助服务</div>
      <div class="self-service-box">
        <div
          v-for="(item, index) in serviceLists"
          class="self-service-item"
          @click="goService(item)"
          :key="index"
        >
          <div class="">
            <img class="service-icon" alt="" :src="item.icon" mode="" />
            <div>{{ item.desc }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="mask-box" @click="showModal = false" v-if="showModal">
      <div class="mask-content" @click.stop="">
        <div class="confirm-bd">
          {{
            confirmType
              ? "购买成功，联系客服开始整理题目"
              : "请复制链接到微信中打开"
          }}
        </div>
        <div class="confirm-footer">
          <div class="confirm-ok" v-if="confirmType" @click="handleContact()">
            联系客服
          </div>
          <div
            class="confirm-ok"
            v-clipboard:success="copySuccess"
            v-clipboard:copy="copyData"
            v-else
          >
            复制链接
          </div>
        </div>
      </div>
    </div>
    <ContactImg :visible="showContact" @hideVisible="handleContact()" />
    <template v-if="showLogin">
      <ScanLogin
        @hideVisible="handleScan()"
        :type="qrcodeType"
        :targetIndex="productIndex"
        :productList="productList"
        :payType="payType"
        :src="loginQrcode"
      />
    </template>

    <template v-if="showScan">
      <scan-code
        src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20211013/3cd24fad2262b8ef5e684b8e2c9759c3.png"
        @hideVisible="handleScanCode"
      ></scan-code>
    </template>
  </div>
</template>
<script>
import questionOnly from "@/utils/questionOnly";
import {
  jumpWxAuth,
  getToken,
  isMobile,
  isWeixin,
  verifyAuth,
  showServiceAble,
  getQueryString,
  vipClick,
  handleCode
} from "@/utils/common";
import api from "@/utils/api";
import { Toast, Dialog } from "vant";
import ContactImg from "@/components/contactImg";
import ScanLogin from "@/components/scanLogin";
import RightCode from "../../components/rightCode.vue";
import ScanCode from "@/components/scanCode.vue";
import { throttle } from "lodash";
import { handleZI } from "../../utils/common";

let checkTime = 0;
let intervalAsk;

export default {
  data() {
    return {
      copyData: "https://cert.xiaoxiaodati.com/orgQs",
      confirmType: 0,
      serviceLists: [
        {
          type: 0,
          desc: "高级版",
          icon:
            "https://cdn-xcx-qunsou.weiyoubot.cn/material/2024-01-19/a7c5df9c5e3ddfd8457a74a9647ba71a.svg",
          url: "/pages/vip/vip"
        },
        {
          type: 1,
          desc: "错题本",
          icon:
            "https://cdn-xcx-qunsou.weiyoubot.cn/material/2024-01-19/9ff845028cddb4e6f02dd153d9e8ecaf.svg",
          url: "/pages/wrongbook/wrongbookpay/wrongbookpay"
        }
        // {
        //   type: 2,
        //   desc: "AI出题",
        //   icon: "https://cdn-xcx-qunsou.weiyoubot.cn/material/2024-01-19/c5bef497e95267213d6876e990299f1f.svg",
        //   url: "https://mp.weixin.qq.com/s/QmxbTawllW1FNsWuXKbrhg",
        // },
      ],
      count: 1,
      payType: 0,
      showScan: false,
      showLogin: false,
      loginQrcode: "",
      qrcodeType: 0,
      isWeixin: isWeixin(),
      isMobile: isMobile(),
      showContact: false,
      showModal: false,
      productIndex: 0,
      productList: [],
      hasUserInfo: false,
    };
  },
  components: {
    [Toast.name]: Toast,
    [Dialog.name]: Dialog,
    ContactImg,
    ScanLogin,
    RightCode,
    ScanCode
  },
  async mounted() {
    if (intervalAsk) {
      clearInterval(intervalAsk);
      intervalAsk = null;
    }
    this.getProduct();
    let loginStatus = await verifyAuth();
    if (loginStatus) {
      this.handleUserInfo();
    } else {
      if (this.isWeixin) {
        if (getToken()) {
          jumpWxAuth();
        } else {
          if (!getToken() && getQueryString("code")) {
            let res = await handleCode(getQueryString("code"));
            if (res) {
              this.handleUserInfo();
              // let arr = document.location.toString().split("&code=")[0];
              // window.location.replace(arr);
            }
            return;
          }
        }
      } else {
        if (!this.isMobile) {
          // pc
          this.getLoginCode();
        }
      }
    }
    //
  },
  methods: {
    copySuccess() {
      Toast("复制成功");
    },
    modalClick() {},
    goService(item) {
      if (item.type === 0) {
        this.$router.push({ name: "vip" });
      } else if (item.type === 1) {
        this.$router.push({ name: "serviceBuy" });
      }
    },
    handleCount(type) {
      if (type == "add") {
        if (this.productList[this.productIndex].item_count * this.count == 1000)
          return;
        this.count = this.count + 1;
      } else if (type == "reduce") {
        if (this.productList[this.productIndex].item_count * this.count == 100)
          return;
        this.count = this.count - 1;
      }
    },
    handleScanCode() {
      this.showScan = !this.showScan;
    },
    getProduct() {
      questionOnly
        .get("/xcx/ques/v2/produce/detail", {
          type: 3,
          loadingMsg: "no"
        })
        .then(res => {
          if (res.sta == 0) {
            if (res.data.product_list) {
              let product_list = res.data.product_list || [];
              if (!localStorage.getItem("continue_pay")) {
                let checkedIndex = 0;
                product_list.forEach((item, index) => {
                  if (item.checked) {
                    checkedIndex = index;
                  }
                });
                this.productIndex = checkedIndex;
              }
              this.productList = product_list;
            }
          }
        });
    },

    getLoginCode() {
      var timestamp = new Date().getTime();
      var myToken =
        timestamp + Math.ceil(Math.random() * 1000000000000000) + "";
      // 获取二维码  开始轮询请求，如果返回ok，清除轮询
      questionOnly
        .get("/xcx/ques_web/v1/qrcode", { token: myToken })
        .then(res => {
          if (res.sta == 0) {
            this.loginQrcode = res.data.qrcode;
            this.qrcodeType = 0;
            if (!this.showLogin) this.showLogin = true;
            checkTime = 0;
            this.checkLoginSuccess(myToken);
          } else {
            Toast(res.msg || "请求失败");
          }
        });
    },
    getPayCode() {
      questionOnly
        .post("/xcx/ques/v1/order", {
          access_token: getToken(),
          type: "handle_items",
          count: this.productList[this.productIndex].item_count * this.count,
          pay_source: 1 // 付费来源 1:h5, 2:pc, 3:腾讯会议, 默认为1
        })
        .then(res => {
          if (res.sta == 0) {
            this.loginQrcode = res.data.qrcode;
            this.qrcodeType = 1;
            this.showLogin = true;
            checkTime = 0;
            this.checkPaySuccess(res.data.order_id);
          } else {
            Toast(res.msg || "请求失败");
          }
        });
    },
    checkPaySuccess(order_id) {
      clearTimeout(intervalAsk);
      checkTime++;
      if (checkTime > 20) {
        checkTime = 0;
        this.getPayCode();
        return;
      }
      questionOnly
        .get("/xcx/ques/v1/order_status", {
          access_token: getToken(),
          order_id,
          loadingMsg: "no"
        })
        .then(res => {
          if (res.sta === -1) {
            intervalAsk = setTimeout(() => {
              this.checkPaySuccess(order_id);
            }, 3000);
          } else {
            // 支付成功
            this.showLogin = false;
            this.confirmType = 1;
            this.showModal = true;
          }
        });
    },
    checkLoginSuccess(myToken) {
      clearTimeout(intervalAsk);
      checkTime++;
      if (checkTime > 20) {
        checkTime = 0;
        this.getLoginCode();
        return;
      }
      questionOnly
        .get("/xcx/ques_web/v1/check_status", {
          token: myToken,
          loadingMsg: "no"
        })
        .then(res => {
          if (res.sta === -1) {
            intervalAsk = setTimeout(() => {
              this.checkLoginSuccess(myToken);
            }, 3000);
          } else {
            // 登录成功
            localStorage.setItem("token", res.data.access_token);
            handleZI(res.data.mp_openid)
            setTimeout(() => {
              this.showLogin = false;
              this.handleUserInfo();
            }, 100);
          }
        });
    },
    handleScan() {
      if (intervalAsk) {
        clearInterval(intervalAsk);
        intervalAsk = null;
      }
      this.showLogin = !this.showLogin;
    },
    async handleContact() {
      this.showModal = false;
      let res = await showServiceAble();
      if (res) {
        this.showContact = !this.showContact;
      }
    },
    toAgreement() {
      this.$router.push({ name: "agreement" });
    },
    closeConfirm() {
      this.showModal = false;
    },
    handleLaunchFn() {},
    handleErrorFn() {},
    // 价格切换
    changeProduct(e) {
      this.productIndex = e;
    },
    //获取用户信息
    handleUserInfo(refresh) {
      let param = { access_token: getToken() };
      if (refresh) {
        param.refresh = 1;
      }
      questionOnly.get(api.question.getServiceDetail, param).then(res => {
        if (res.sta == 0) {
          this.hasUserInfo = true;
          let continue_pay = localStorage.getItem("continue_pay") || 0;
          if (localStorage.getItem("msg_type"))
            localStorage.removeItem("msg_type");
          if (getQueryString("msg_type") && getQueryString("msg_type") > 0) {
            msg_type = getQueryString("msg_type");
          }
          if (continue_pay) {
            localStorage.removeItem("continue_pay");
            this.pay();
          }
        } else if (res.sta == -500) {
          jumpWxAuth();
        }
      });
    },
    // 支付
    pay: throttle(
      async function() {
        if (!this.isWeixin) {
          if (this.isMobile) {
            this.confirmType = 0;
            this.showModal = true;
            return;
          } else {
            if (!this.hasUserInfo) {
              return this.getLoginCode();
            } else {
              return this.getPayCode();
            }
          }
        } else if (this.isWeixin && !this.hasUserInfo) {
          // 微信里面没登录
          localStorage.setItem("continue_pay", 1);
          return jumpWxAuth();
        }
        if (!this.isMobile) {
          return this.getPayCode();
        }
        let self = this;
        let count = this.productList[this.productIndex].item_count * this.count;
        let param = {
          access_token: getToken(),
          type: "handle_items",
          source: "h5",
          count
        };
        questionOnly.post(api.question.bookVipBuy, param).then(res => {
          if (res.sta == 0) {
            this.console = JSON.stringify(res.data);
            window.wx.chooseWXPay({
              timestamp: res.data.timeStamp,
              nonceStr: res.data.nonceStr,
              package: res.data.package,
              signType: res.data.signType,
              paySign: res.data.paySign,
              appId: res.data.appId,
              success: function(res) {
                self.confirmType = 1;
                self.showModal = true;
              },
              fail: error => {
                Toast(error.errMsg);
              },
              cancel: message => {
                // Toast(message.errMsg)
              }
            });
          } else {
            Toast(res.msg);
          }
        });
      },
      2000,
      { trailing: false }
    )
  },
  destroyed() {
    if (intervalAsk) {
      clearInterval(intervalAsk);
      intervalAsk = null;
    }
  }
};
</script>

<style scoped lang="scss">
.org-qs {
  background: #ffffff;
  max-width: 500px;
  min-width: 320px;
  margin: 0 auto;
  position: relative;
  transition: none;
  min-height: 100vh;
  padding: 10px 15px 0;
  box-sizing: border-box;
}

.productList {
  margin-top: 15px;
  display: flex;
  // justify-content: space-between;
  flex-wrap: nowrap;
  overflow-x: scroll;
  padding: 1px 1px 0 1px;
}

.product-item {
  background: #ffffff;
  border-radius: 4px;
  height: 130px;
  min-width: 95px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  position: relative;
  box-sizing: border-box;
  border: 2px solid transparent;
  margin-bottom: 15px;
  margin-right: 15px;
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.08);
  .info {
    position: absolute;
    left: -2px;
    top: -2px;
    background: #fe523c;
    // background: linear-gradient(90deg, #ffc083 0%, #ff7d00 100%);
    border-radius: 4px 0 15px;
    font-size: 12px;
    width: 79px;
    text-align: center;
    color: #ffffff;
    line-height: 18px;
  }
}
.product-item.active {
  border: 2px solid #1890ff;
  color: #1890ff;
}
.product-item img {
  width: 28px;
  height: 28px;
  position: absolute;
  right: -2px;
  bottom: -2px;
}

.name {
  font-size: 14px;
  line-height: 14px;
  color: #262626;
}

.price {
  font-weight: 900;
  font-size: 20px;
  line-height: 30px;
  margin-top: 2px;
}

.discount {
  font-size: 12px;
  line-height: 18px;
  text-decoration-line: line-through;
  color: #999999;
}
.infos {
  background: #f8fbff;
  padding: 10px 15px;
  color: #999999;
  font-size: 13px;
  border-radius: 4px;
}
.info-title {
  font-size: 15px;
  font-weight: bold;
  line-height: 20px;
  margin-bottom: 5px;
  color: #262626;
  display: flex;
  align-items: center;
}
.info-title span {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #1890ff;
  display: inline-block;
  margin-right: 5px;
}
.price-icon {
  font-size: 12px;
}
.buy-count {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 15px;
  height: 45px;
  margin-bottom: 15px;
}
.pick {
  display: flex;
  align-items: center;
}
.pick span {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 25px;
  height: 25px;
  border-radius: 2px;
  background: #f2f2f7;
  font-size: 15px;
  margin-left: 3px;
  cursor: pointer;
}
.fill-input {
  min-width: 50px;
  height: 25px;
  line-height: 25px;
  text-align: center;
  background: #f2f2f7;
  border: none;
}
.buy-btn {
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
  font-size: 15px;
  font-weight: bold;
  color: #ffffff;
  background: #1890ff;
  cursor: pointer;
}
.pick .reduce {
  font-size: 18px;
}
.pick .reduce.gray {
  color: #ccc
}
.pick .add.gray {
  color: #ccc
}
.buy-btn .r {
  margin-left: 5px;
}
.self-service-box {
  display: flex;
  margin-top: 15px;
}

.self-service-head {
  font-size: 17px;
  line-height: 21px;
  margin: 30px 0 15px;
}

.self-service-item {
  text-align: center;
  font-size: 14px;
  margin-right: 15px;
  // display: flex;
  width: 67px;
  border-radius: 4px;
  text-align: center;
  // align-items: center;
  // justify-content: space-between;
  // padding: 16px;
  box-sizing: border-box;
  height: 54px;
  cursor: pointer;
}

.service-icon {
  width: 24px;
  height: 24px;
  margin: 7px 0;
}

.mask-box {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 22px;
  z-index: 9;
}
.mask-content {
  background: white;
  width: 330px;
  box-sizing: border-box;
  border-radius: 5px;
  text-align: center;
}
.confirm-header {
  font-size: 17px;
  padding: 15px 0 7px;
  font-weight: 800;
}
.confirm-bd {
  text-align: left;
  color: #262626;
  font-size: 16px;
  line-height: 24px;
  padding: 30px 40px;
  text-align: center;
}
.confirm-footer {
  // margin: 12px;
  /*width: px580);*/
  height: 54px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid #e0e0e0;
}
.confirm-footer div {
  flex: 1;
  text-align: center;
  font-weight: 700;
  font-size: 16px;
}
.confirm-ok {
  color: #1890ff;
  height: 54px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 16px;
  border-left: 1px solid #eee;
  cursor: pointer;
  button {
    font-weight: 700;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/orgQs/orgQs.vue